"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var _ = require("underscore");
var classNames_1 = require("../../../utilities/classNames");
var dateHelpers_1 = require("../../../utilities/dateHelpers");
var formatting_1 = require("../../../utilities/formatting");
var grid_1 = require("../../layout/grid");
var form_1 = require("../form");
var formCore_1 = require("../formCore");
var validationWrapper_1 = require("../validationWrapper");
var options_1 = require("./options");
var TimeInput = /** @class */ (function (_super) {
    tslib_1.__extends(TimeInput, _super);
    function TimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDataChanged = function (d) {
            _this.setState(d, function () {
                if (!_this.props.onChange || formatting_1.Formatting.isNullOrUndefined(d.hours)) {
                    return;
                }
                if (formatting_1.Formatting.isNullOrUndefined(d.minutes)) {
                    if (_this.props.zeroMinutesOnHourSelected) {
                        _this.setState({ minutes: 0 });
                        _this.props.onChange(formatting_1.Formatting.twoDigitNumber(d.hours) + ":00");
                    }
                }
                else {
                    _this.props.onChange(formatting_1.Formatting.twoDigitNumber(d.hours) + ":" + formatting_1.Formatting.twoDigitNumber(d.minutes));
                }
            });
        };
        _this.state = { hours: null, minutes: null };
        return _this;
    }
    TimeInput.prototype.componentWillMount = function () {
        if (this.props.time) {
            var time = dateHelpers_1.DateHelpers.getTimeParts(this.props.time);
            this.setState({ hours: time.hours, minutes: time.minutes });
        }
    };
    TimeInput.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.time) {
            var newTime = dateHelpers_1.DateHelpers.getTimeParts(newProps.time);
            var _a = this.state, hours = _a.hours, minutes = _a.minutes;
            var needsUpdate = void 0;
            if (newTime.hours !== hours) {
                hours = newTime.hours;
                needsUpdate = true;
            }
            if (newTime.minutes !== minutes) {
                minutes = newTime.minutes;
                needsUpdate = true;
            }
            if (needsUpdate) {
                this.setState({ hours: hours, minutes: minutes });
            }
        }
        else {
            this.setState({ hours: null, minutes: null });
        }
    };
    TimeInput.prototype.render = function () {
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var minutes = _.range(0, 60, this.props.minuteStep || 1);
        var hourOptions = options_1.buildOptions(this.props.hourLabel, TimeInput.hours, function (v) { return v; }, function (v) { return formatting_1.Formatting.twoDigitNumber(v); });
        var minuteOptions = options_1.buildOptions(this.props.minuteLabel, minutes, function (v) { return v; }, function (v) { return formatting_1.Formatting.twoDigitNumber(v); });
        return (React.createElement(form_1.Form, { className: classNames_1.ClassHelpers.classNames("time-input", "armstrong-input", this.props.className, this.props.disabled ? "input-disabled" : null, { "show-validation": this.props.validationMode !== "none" && validationMessage }), dataBinder: form_1.Form.jsonDataBinder(this.state), onDataChanged: this.handleDataChanged, title: validationMessage },
            React.createElement(grid_1.Grid, null,
                React.createElement(grid_1.Row, null,
                    React.createElement(grid_1.Col, null,
                        React.createElement("select", tslib_1.__assign({ tabIndex: this.props.tabIndex }, form_1.Form.Bind.selectNumeric("hours"), { disabled: this.props.disabled }, formCore_1.DataValidationMessage.spread(validationMessage)), hourOptions)),
                    React.createElement(grid_1.Col, null,
                        React.createElement("select", tslib_1.__assign({ tabIndex: this.props.tabIndex }, form_1.Form.Bind.selectNumeric("minutes"), { disabled: this.props.disabled }, formCore_1.DataValidationMessage.spread(validationMessage)), minuteOptions))),
                React.createElement(validationWrapper_1.ValidationLabel, { message: validationMessage, mode: this.props.validationMode, wrapper: function (p) { return (React.createElement(grid_1.Row, { height: "auto" },
                        React.createElement(grid_1.Col, tslib_1.__assign({}, p)))); } }))));
    };
    TimeInput.hours = _.range(0, 24);
    TimeInput.defaultProps = {
        time: "",
        hourLabel: "HH",
        minuteLabel: "MM",
        validationMode: "none",
    };
    return TimeInput;
}(React.Component));
exports.TimeInput = TimeInput;
